import { useEffect } from 'react';
import { useState } from 'react';
import { createContext, FC, useContext } from 'react';
import { TTip } from './interfaces';

const TipsContext = createContext<
  | {
      tips: { [key: string]: TTip };
      toggleTips: () => void;
      show: boolean;
      enabled?: boolean;
    }
  | undefined
>(undefined);

function groupDuplicates(arr: TTip[], key: string) {
  const counter: TTip[] = [];

  arr.forEach((item) => {
    if (item.key === key) {
      counter.push(item);
    }
  });

  return counter;
}

export const TipsProvider: FC<{ enabled?: boolean; baseUrl?: string }> = ({
  children,
  enabled,
  baseUrl = 'https://raw.githubusercontent.com/4d/Web-studio-TIPS/main',
}) => {
  const [{ tips, show }, setState] = useState<{
    tips: { [key: string]: TTip };
    show: boolean;
  }>({
    tips: {},
    show: true,
  });

  useEffect(() => {
    const abortController = new AbortController();

    try {
      fetch(
        `${baseUrl}/tips.json`,
        // 'tips.json',
        { signal: abortController.signal },
      )
        .then((res) => res.json())
        .then((json: TTip[]) => {
          const result = json.reduce((prev, curr) => {
            if (groupDuplicates(json, curr.key).length > 1) {
              return {
                ...prev,
                [curr.key]: {
                  type: 'carousel',
                  pages: groupDuplicates(json, curr.key),
                },
              };
            }

            return {
              ...prev,
              [curr.key]: curr,
            };
          }, {});

          setState((state) => ({ ...state, tips: result }));
        });
    } catch (ex) {
      // proceed
    }

    return () => {
      abortController.abort(); // Cancel the request if component unmounts
    };
  }, []);

  const toggleTips = () => {
    setState((state) => ({ ...state, show: !show }));
  };

  return (
    <TipsContext.Provider value={{ tips, toggleTips, show, enabled }}>
      {children}
    </TipsContext.Provider>
  );
};

export const useTip = (key?: string) => {
  const context = useContext(TipsContext);

  if (context === undefined) {
    throw new Error('useTip must be used within a TipsContext');
  }

  return {
    tip: key ? context.tips[key] : null,
    toggleTips: context.toggleTips,
    show: context.show,
    enabled: context.enabled,
  };
};
